export function parseDataConfig(raw: string | null): Record<string, unknown> {
  if (!raw) return {};
  try {
    return JSON.parse(raw) as Record<string, unknown>;
  } catch {
    try {
      return JSON.parse(decodeURIComponent(raw)) as Record<string, unknown>;
    } catch {
      console.error("[parseDataConfig] Failed to parse data-config:", raw.slice(0, 100));
      return {};
    }
  }
}
